import React, { useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
// @ts-ignore
import ApexCharts from 'apexcharts';
import WireframeTimeline from '../components/WireframeTimeline';

// Tuney image paths
const tuneyGridV1 = '/images/tuney-grid-v1.png';
const tuneyUsersPersona = '/images/tuney-users-persona.png';
const tuneySketch1 = '/images/tuney-sketch-1.png';
const tuneySketch2 = '/images/tuney-sketch-2.png';
const tuneyWireframe = '/images/tuney-wireframe.png';
const tuneyWireframeLoFi = '/images/tuney-lofi-wireframe.png';
const tuneyStemSeparate = '/video/tuney-stem-seperate.mp4';
const tuneyQuickStart = '/images/tuney-quick-start.png';
const tuneyAudioRegionStyleTransfer = '/video/tuney-audio-region-style-transfer.mp4';
const tuneyAudioTrackStyleTransfer = '/video/tuney-audio-track-style-transfer.mp4';
const tuneyTimeline = '/images/tuney-timeline.png';
const tuneyMyFiles = '/images/tuney-my-files.png';
const tuneyCoProducerFullScreen = '/images/tuney-co-producer-full-screen.png';
const tuneyQuickStartModal = '/images/tuney-quick-start-modal.png';
const tuneyTimelinePopovers = '/images/tuney-timeline-popovers.png';
const tuneyCoProducerFullScreenLg = '/images/tuney-co-producer-full-screen-lg.png';
const tuneySoundLibrary = '/images/tuney-sound-library.png';
const tuneyRecordAudio = '/images/tuney-record-audio.png';
const tuneyDesignOne = '/images/tuney-design-1.png';
const tuneyDesignTwo = '/images/tuney-design-2.png';
const tuneyDesignThree = '/images/tuney-design-3.png';
const tuneyDesignFour = '/images/tuney-design-4.png';
const tuneyDesignFive = '/images/tuney-design-5.png';

// SVG paths for popover connectors
const svgPaths = {
  p16f87d00: "M198.667 6C198.667 8.94552 201.054 11.3333 204 11.3333C206.946 11.3333 209.333 8.94552 209.333 6C209.333 3.05448 206.946 0.666667 204 0.666667C201.054 0.666667 198.667 3.05448 198.667 6ZM1.00001 6V5H1.26792e-05L1.22392e-05 6L1.00001 6ZM-9.6165e-07 36L-1.40168e-06 37L2 37L2 36L0.999999 36L-9.6165e-07 36ZM204 6V5H1.00001V6V7H204V6ZM1.00001 6L1.22392e-05 6L-9.6165e-07 36L0.999999 36L2 36L2.00001 6L1.00001 6Z",
  p2165b400: "M0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM6.00001 82L5.00001 82L5.00001 83L6.00001 83L6.00001 82ZM92 82H93V81L92 81L92 82ZM91 117.5V118.5H93V117.5H92H91ZM6 6L5 6L5.00001 82L6.00001 82L7.00001 82L7 6L6 6ZM6.00001 82L6.00001 83L92 83L92 82L92 81L6.00001 81L6.00001 82ZM92 82H91V117.5H92H93V82H92Z",
  p35a7da00: "M95.6667 6C95.6667 8.94552 98.0545 11.3333 101 11.3333C103.946 11.3333 106.333 8.94552 106.333 6C106.333 3.05448 103.946 0.666667 101 0.666667C98.0545 0.666667 95.6667 3.05448 95.6667 6ZM1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7V6V5ZM101 6V5H1V6V7H101V6Z",
  p36b0eb80: "M39.6664 6C39.6664 8.94552 42.0542 11.3333 44.9998 11.3333C47.9453 11.3333 50.3331 8.94552 50.3331 6C50.3331 3.05448 47.9453 0.666667 44.9998 0.666667C42.0542 0.666667 39.6664 3.05448 39.6664 6ZM44.9998 82V83H45.9998L45.9998 82L44.9998 82ZM1.00001 82V81H6.64413e-06L6.64413e-06 82L1.00001 82ZM6.64413e-06 117.5L6.64413e-06 118.5L2.00001 118.5L2.00001 117.5L1.00001 117.5L6.64413e-06 117.5ZM44.9998 6L43.9998 6L43.9998 82L44.9998 82L45.9998 82L45.9998 6L44.9998 6ZM44.9998 82V81H1.00001V82V83H44.9998V82ZM1.00001 82L6.64413e-06 82L6.64413e-06 117.5L1.00001 117.5L2.00001 117.5L2.00001 82L1.00001 82Z",
  p3fd1e100: "M101.667 6C101.667 8.94552 104.054 11.3333 107 11.3333C109.946 11.3333 112.333 8.94552 112.333 6C112.333 3.05448 109.946 0.666667 107 0.666667C104.054 0.666667 101.667 3.05448 101.667 6ZM1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7V6V5ZM107 6V5H1V6V7H107V6Z",
};

interface PopoverData {
  text: string;
  containerStyle: {
    height: string;
    left?: string;
    right?: string;
    top: string;
    width: string;
  };
  delay: number;
  connectorPath: string;
  connectorStyle: any;
  dotStyle: any;
  contentStyle: {
    left: string;
    top: string;
  };
  rotateConnector?: boolean;
}

function PopoverWithConnector({
  text,
  containerStyle,
  delay,
  connectorPath,
  connectorStyle,
  dotStyle,
  contentStyle,
  rotateConnector = false,
  scale = 1,
}: PopoverData & { scale?: number }) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: "-100px",
  });

  return (
    <motion.div
      ref={ref}
      className="absolute hidden md:block"
      style={containerStyle}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: 0.95 }
      }
      transition={{
        duration: 0.6,
        delay: delay,
        ease: [0.645, 0.045, 0.355, 1.0],
      }}
    >
      {/* Glowing dot indicator */}
      <motion.div
        className="absolute hidden md:block"
        style={{
          ...dotStyle,
          width: `${30 * scale}px`,
          height: `${30 * scale}px`,
        }}
        animate={{
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          delay: delay + 0.5,
        }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 30 30"
        >
          <circle
            cx="15"
            cy="15"
            fill="white"
            fillOpacity="0.2"
            r="15"
          />
        </svg>
      </motion.div>

      {/* Connector line with SVG */}
      <div className="absolute hidden md:block" style={{ ...connectorStyle, transform: rotateConnector ? 'rotate(180deg)' : undefined }}>
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox={connectorStyle.viewBox}
        >
          <path d={connectorPath} fill="#84CC16" />
        </svg>
      </div>

      {/* Popover content */}
      <div
        className="absolute bg-zinc-950 rounded-lg"
        style={{
          ...contentStyle,
          width: `${207 * scale}px`,
        }}
      >
        <div
          className="box-border content-stretch flex gap-[10px] items-center overflow-clip relative"
          style={{
            padding: `${16 * scale}px`,
            width: `${207 * scale}px`,
          }}
        >
          <div
            className="basis-0 flex flex-col font-mono-recursive grow justify-center min-h-px min-w-px not-italic relative shrink-0 text-zinc-300"
            style={{
              fontSize: `${12 * scale}px`,
            }}
          >
            <p style={{ lineHeight: `${20 * scale}px` }}>{text}</p>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="absolute border-2 border-lime-500 border-solid pointer-events-none rounded-md md:rounded-lg"
          style={{
            inset: `${-2 * scale}px`,
          }}
        />
      </div>
    </motion.div>
  );
}

function PortfolioSection() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: "-200px",
  });

  // Calculate scale based on viewport width
  // Base width is 1586px (screenshot width) + some padding
  const baseWidth = 1700; // Slightly larger than screenshot for padding
  const minScale = 0.3; // Minimum scale for mobile
  const maxScale = 1.2; // Maximum scale for large screens

  // State for current scale factor
  const [currentScale, setCurrentScale] = React.useState(() =>
    Math.max(minScale, Math.min(maxScale, window.innerWidth / baseWidth))
  );

  // Update scale on window resize
  React.useEffect(() => {
    const handleResize = () => {
      const newScale = Math.max(minScale, Math.min(maxScale, window.innerWidth / baseWidth));
      setCurrentScale(newScale);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [baseWidth, minScale, maxScale]);

  // Helper function to scale values
  const scale = (value: number) => value * currentScale;

  const popovers: PopoverData[] = [
    {
      // Popover - "Easy click, or drag and drop audio files to upload"
      text: "Easy click, or drag and drop audio files to upload",
      containerStyle: {
        height: `${scale(72)}px`,
        left: `${scale(196)}px`,
        top: `${scale(343)}px`,
        width: `${scale(322)}px`,
      },
      delay: 0.2,
      connectorPath: svgPaths.p35a7da00,
      connectorStyle: {
        top: `${scale(31)}px`,
        left: `${scale(207)}px`,
        width: `${scale(100)}px`,
        viewBox: "0 0 107 12",
      },
      dotStyle: { top: `${scale(21)}px`, left: `${scale(287)}px` },
      contentStyle: { left: "0px", top: "0px" },
    },
    {
      // Popover1 - "Connect audio directly from Dropbox"
      text: "Connect audio directly from Dropbox",
      containerStyle: {
        height: `${scale(199)}px`,
        left: `${scale(1003)}px`,
        top: `${scale(599)}px`,
        width: `${scale(207)}px`,
      },
      delay: 0.4,
      connectorPath: svgPaths.p2165b400,
      connectorStyle: {
        top: `${scale(15)}px`,
        left: `${scale(15)}px`,
        width: `${scale(86)}px`,
        height: `${scale(111.5)}px`,
        viewBox: "0 0 93 119",
      },
      dotStyle: { top: `${scale(5)}px`, left: `${scale(5.5)}px` },
      contentStyle: { left: "0px", top: `${scale(127)}px` },
    },
    {
      // Popover2 - "Connect audio directly from SoundCloud"
      text: "Connect audio directly from SoundCloud",
      containerStyle: {
        height: `${scale(199)}px`,
        left: `${scale(544)}px`,
        top: `${scale(599)}px`,
        width: `${scale(207)}px`,
      },
      delay: 0.6,
      connectorPath: svgPaths.p36b0eb80,
      connectorStyle: {
        top: `${scale(15)}px`,
        left: `${scale(100)}px`,
        width: `${scale(44)}px`,
        height: `${scale(111.5)}px`,
        viewBox: "0 0 51 119",
      },
      dotStyle: { top: `${scale(5)}px`, left: `${scale(124)}px` },
      contentStyle: { left: "0px", top: `${scale(127)}px` },
    },
    {
      // Popover3 - "Start with natural language or genre and style tags"
      text: "Start with natural language or genre and style tags",
      containerStyle: {
        height: `${scale(118)}px`,
        left: `${scale(185)}px`,
        top: `${scale(515)}px`,
        width: `${scale(322)}px`,
      },
      delay: 0.8,
      connectorPath: svgPaths.p16f87d00,
      connectorStyle: {
        top: `${scale(15)}px`,
        left: `${scale(104)}px`,
        width: `${scale(203)}px`,
        height: `${scale(30)}px`,
        viewBox: "0 0 210 37",
      },
      dotStyle: { top: `${scale(4)}px`, left: `${scale(287)}px` },
      contentStyle: { left: "0px", top: `${scale(46)}px` },
    },
    {
      // Popover4 - "Explore Tuney's curated sound library"
      text: "Explore Tuney's curated sound library",
      containerStyle: {
        height: `${scale(72)}px`,
        left: `${scale(1061)}px`,
        top: `${scale(502)}px`,
        width: `${scale(328)}px`,
      },
      delay: 1.0,
      connectorPath: svgPaths.p3fd1e100,
      connectorStyle: {
        top: `${scale(31)}px`,
        left: `${scale(15)}px`,
        width: `${scale(106)}px`,
        viewBox: "0 0 113 12",
      },
      dotStyle: {
        top: `${scale(22)}px`,
        left: `${scale(6)}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: "rotate(180deg)",
      },
      contentStyle: { left: `${scale(121)}px`, top: "0px" },
      rotateConnector: true,
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="relative w-full flex items-center justify-center"
    >
      <motion.div
        className="relative origin-center"
        style={{
          transform: `scale(clamp(${minScale}, calc(100vw / ${baseWidth}), ${maxScale}))`,
        }}
        initial={{ opacity: 0 }}
        animate={
          isInView
            ? { opacity: 1 }
            : { opacity: 0 }
        }
        transition={{ duration: 1, delay: 0.3 }}
      >
        {/* Main screenshot container */}
        <img
          alt=""
          className="max-w-none object-50%-50% object-cover rounded-lg md:rounded-2xl size-full border border-zinc-800"
          src={tuneyQuickStartModal}
        />

        {/* Animated popovers */}
        {popovers.map((popover, index) => (
          <PopoverWithConnector
            key={index}
            text={popover.text}
            containerStyle={popover.containerStyle}
            delay={popover.delay}
            connectorPath={popover.connectorPath}
            connectorStyle={popover.connectorStyle}
            dotStyle={popover.dotStyle}
            contentStyle={popover.contentStyle}
            rotateConnector={popover.rotateConnector}
            scale={currentScale}
          />
        ))}
      </motion.div>
    </section>
  );
}

interface MusicPopoverData {
  text: string;
  dotStyle: {
    left: string;
    top: string;
  };
  popoverStyle: {
    left: string;
    top: string;
  };
  delay: number;
}

function MusicPopover({ text, style, dotStyle, delay, scale = 1 }: { text: string; style: any; dotStyle: any; delay: number; scale?: number }) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: "-100px",
  });

  return (
    <>
      {/* Glowing dot indicator */}
      {/* <motion.div
        className="absolute"
        style={{
          ...dotStyle,
          width: `${30 * scale}px`,
          height: `${30 * scale}px`,
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={
          isInView
            ? { opacity: 1, scale: 1 }
            : { opacity: 0, scale: 0.8 }
        }
        transition={{
          duration: 0.6,
          delay: delay,
          ease: [0.645, 0.045, 0.355, 1.0],
        }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 30 30"
        >
          <circle
            cx="15"
            cy="15"
            fill="white"
            fillOpacity="0.2"
            r="15"
          />
          <circle cx="15" cy="15" fill="#84CC16" r="6" />
        </svg>
      </motion.div> */}

      {/* Pulsing animation overlay for the dot */}
      <motion.div
        className="absolute hidden md:block"
        style={{
          ...dotStyle,
          width: `${30 * scale}px`,
          height: `${30 * scale}px`,
        }}
        animate={{
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          delay: delay + 0.5,
        }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 30 30"
        >
          <circle
            cx="15"
            cy="15"
            fill="white"
            fillOpacity="0.2"
            r="15"
          />
          <circle cx="15" cy="15" fill="#84CC16" r="6" />
        </svg>
      </motion.div>

      <motion.div
        ref={ref}
        className="absolute bg-zinc-950 rounded-lg hidden md:block"
        style={{
          ...style,
          width: `${207 * scale}px`,
        }}
        initial={{ opacity: 0, scale: 0.95, y: -5 }}
        animate={
          isInView
            ? { opacity: 1, scale: 1, y: 0 }
            : { opacity: 0, scale: 0.95, y: -5 }
        }
        transition={{
          duration: 0.6,
          delay: delay + 0.2,
          ease: [0.645, 0.045, 0.355, 1.0],
        }}
      >
        <div
          className="box-border content-stretch flex gap-[10px] items-center overflow-clip relative"
          style={{
            padding: `${16 * scale}px`,
            width: `${207 * scale}px`,
          }}
        >
          <div
            className="basis-0 flex flex-col font-mono-recursive grow justify-center min-h-px min-w-px not-italic relative shrink-0 text-zinc-300"
            style={{
              fontSize: `${12 * scale}px`,
            }}
          >
            <p style={{ lineHeight: `${20 * scale}px` }}>{text}</p>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="absolute border-2 border-lime-500 border-solid pointer-events-none rounded-md md:rounded-lg"
          style={{
            inset: `${-2 * scale}px`,
          }}
        />
      </motion.div>
    </>
  );
}

function MusicGenerationSection() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: "-200px",
  });

  // Calculate scale based on viewport width
  const baseWidth = 1700;
  const minScale = 0.3;
  const maxScale = 1.2;

  // State for current scale factor
  const [currentScale, setCurrentScale] = React.useState(() =>
    Math.max(minScale, Math.min(maxScale, window.innerWidth / baseWidth))
  );

  // Update scale on window resize
  React.useEffect(() => {
    const handleResize = () => {
      const newScale = Math.max(minScale, Math.min(maxScale, window.innerWidth / baseWidth));
      setCurrentScale(newScale);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [baseWidth, minScale, maxScale]);

  // Helper function to scale values
  const scale = (value: number) => value * currentScale;

  const musicPopovers: MusicPopoverData[] = [
    {
      // "Generate new music from a text prompt"
      text: "Generate new music from a text prompt",
      dotStyle: {
        left: `${scale(298)}px`,
        top: `${scale(214)}px`,
      },
      popoverStyle: {
        left: `${scale(209)}px`,
        top: `${scale(251)}px`,
      },
      delay: 0.2,
    },
    {
      // "Generate new music on a track from a text prompt"
      text: "Generate new music on a track from a text prompt",
      dotStyle: {
        left: `${scale(569)}px`,
        top: `${scale(147)}px`,
      },
      popoverStyle: {
        left: `${scale(480)}px`,
        top: `${scale(69)}px`,
      },
      delay: 0.4,
    },
    {
      // "Generate new music on individual audio regions"
      text: "Generate new music on individual audio regions",
      dotStyle: {
        left: `${scale(717)}px`,
        top: `${scale(272)}px`,
      },
      popoverStyle: {
        left: `${scale(755)}px`,
        top: `${scale(251)}px`,
      },
      delay: 0.6,
    },
    {
      // "Generate music on an entire song marker stack"
      text: "Generate music on an entire song marker stack",
      dotStyle: {
        left: `${scale(983)}px`,
        top: `${scale(102)}px`,
      },
      popoverStyle: {
        left: `${scale(1020)}px`,
        top: `${scale(81)}px`,
      },
      delay: 0.8,
    },
    {
      // "Write customer lyrics or generate new ideas"
      text: "Write customer lyrics or generate new ideas",
      dotStyle: {
        left: `${scale(364)}px`,
        top: `${scale(481)}px`,
      },
      popoverStyle: {
        left: `${scale(405)}px`,
        top: `${scale(460)}px`,
      },
      delay: 1.0,
    },
    {
      // "Drop entire folder of stems or individual audio files"  
      text: "Drop entire folder of stems or individual audio files",
      dotStyle: {
        left: `${scale(953)}px`,
        top: `${scale(640)}px`,
      },
      popoverStyle: {
        left: `${scale(864)}px`,
        top: `${scale(678)}px`,
      },
      delay: 1.2,
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="relative w-full flex items-center justify-center overflow-x-hidden"
    >
      <motion.div
        className="relative origin-center"
        style={{
          transform: `scale(clamp(${minScale}, calc(100vw / ${baseWidth}), ${maxScale}))`,
        }}
        initial={{ opacity: 0 }}
        animate={
          isInView
            ? { opacity: 1 }
            : { opacity: 0 }
        }
        transition={{ duration: 1, delay: 0.3 }}
      >
        {/* Main screenshot container */}
        <img
          alt=""
          className="max-w-none object-50%-50% object-cover rounded-lg md:rounded-2xl size-full border border-zinc-800"
          src={tuneyTimelinePopovers}
        />

        {/* Popovers with integrated glowing dots */}
        {musicPopovers.map((popover, index) => (
          <MusicPopover
            key={`popover-${index}`}
            text={popover.text}
            style={popover.popoverStyle}
            dotStyle={popover.dotStyle}
            delay={popover.delay}
            scale={currentScale}
          />
        ))}
      </motion.div>
    </section>
  );
}

const Tuney: React.FC = () => {
  useEffect(() => {
    // Initialize ApexCharts donut chart
    const chartOptions = {
      chart: {
        type: 'donut',
        height: '100%',
      },
      series: [72.2, 27.8],
      labels: ['New users', 'Returning users'],
      colors: ['#3a86ff', '#2ecc71'],
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      plotOptions: {
        pie: {
          donut: {
            size: '70%',
            labels: {
              show: true,
              name: {
                show: true,
                offsetY: 30,
                color: 'currentColor',
                fontSize: '14px'
              },
              value: {
                show: true,
                fontSize: '32px',
                fontWeight: 'bold',
                color: 'currentColor',
                offsetY: -10
              },
              total: {
                show: true,
                label: 'New users',
                formatter: function () {
                  return '72.2%';
                },
                color: 'currentColor',
                fontSize: '14px',
              }
            }
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val + '%';
          }
        }
      }
    };

    let chart: any = null;
    const chartEl = document.querySelector("#donutChart");
    if (chartEl && chartEl.children.length === 0) {
      // Only create chart if element exists and is empty
      chart = new ApexCharts(chartEl, chartOptions);
      chart.render();
    }

    // Quote carousel functionality
    const quotes = [
      "Better control over song components like intro, verse, chorus, and endings is needed.",
      "Innovation distinguishes between a leader and a follower.",
      "Life is what happens to you while you're busy making other plans."
    ];

    let currentQuote = 0;
    const quoteContainer = document.getElementById('quoteContainer');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    const updateQuote = () => {
      if (quoteContainer) {
        const quoteDivs = quoteContainer.querySelectorAll('.quote');
        quoteDivs.forEach((div, index) => {
          if (index === currentQuote) {
            div.classList.add('active', 'opacity-100');
            div.classList.remove('opacity-0');
          } else {
            div.classList.remove('active', 'opacity-100');
            div.classList.add('opacity-0');
          }
        });
      }
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentQuote = (currentQuote - 1 + quotes.length) % quotes.length;
        updateQuote();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentQuote = (currentQuote + 1) % quotes.length;
        updateQuote();
      });
    }

    updateQuote();

    return () => {
      // Cleanup chart
      if (chart) {
        chart.destroy();
      }
    };
  }, []);

  return (
    <div className="flex flex-1 flex-col gap-2">
      <div className="mx-auto max-w-8xl flex flex-1 flex-col gap-2 p-4 md:p-6">
        {/* Hero Section */}
        <section className="grid md:grid-cols-12 my-4 md:my-8">
          <div className="col-span-12 lg:col-start-3 lg:col-span-8 2xl:col-start-4 2xl:col-span-6 space-y-6 md:space-y-12">
            <motion.h1
              className="md:!leading-tight text-3xl md:text-4xl"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              Redesigning Tuney Producer increased retention by 23% and paid conversions by 10%
            </motion.h1>

            <motion.div
              className="grid md:grid-cols-12 md:gap-6 space-y-4 md:space-y-0 col-span-12"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.1, ease: "easeOut"}}
            >
              <div className="md:col-span-5 space-y-4 md:space-y-8">
                <div className="space-y-1 md:space-y-3">
                  <p className="font-mono-recursive md:text-lg">Team</p>
                  <p className="md:text-lg dark:dark:text-zinc-400">1x Designer<span className="mx-2">·</span>4x Software Engineers<span className="mx-2">·</span>1x DSP Engineer</p>
                </div>
                <div className="space-y-1 md:space-y-3">
                  <p className="font-mono-recursive md:text-lg">Tools & Frameworks</p>
                  <p className=" md:text-lg dark:dark:text-zinc-400">Axure RP<span className="mx-1"> · </span>Figma</p>
                </div>
                <div className="space-y-1 md:space-y-3">
                  <p className="font-mono-recursive md:text-lg">Date</p>
                  <p className="md:text-lg dark:dark:text-zinc-400">2025</p>
                </div>
              </div>
              <div className="md:col-span-7 space-y-4 md:space-y-8">
                <div className="space-y-1 md:space-y-3">
                  <p className="font-mono-recursive md:text-lg">Role & Contributions</p>
                  <p className="md:text-lg dark:dark:text-zinc-400">Product Designer<span className="mx-1"> · </span>User research & discovery<span className="mx-1"> · </span>Information Architecture<span className="mx-1"> · </span>Prototyping</p>
                </div>
                <div className="space-y-1 md:space-y-3">
                  <p className="font-mono-recursive md:text-lg">Key Achievements</p>
                  <p className="md:text-lg dark:dark:text-zinc-400">Since launching Tuney Producer in 2025, we've increased user retention by 23% and are seeing steady growth in free-to-paid conversions, with a 10% increase. While it's still early, these initial metrics demonstrate strong product-market fit and user engagement.</p>
                </div>
                <div className="inline-flex mt-4">
                  <a
                    href="https://app.tuney.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mono-recursive md:text-lg transition text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline underline-offset-4 cursor-pointer"
                  >
                    View Website
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Video Section */}
        <section className="mt-8 md:mt-14">
          <div className="mx-auto">
            <motion.video
              className="z-10 overflow-hidden rounded-lg md:rounded-2xl relative border border-zinc-800 w-full"
              autoPlay
              loop
              muted
              playsInline
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <source src={tuneyStemSeparate} type="video/mp4" />
              Your browser does not support the video tag.
            </motion.video>
            <figcaption className="text-center italic pt-2 text-gray-500 font-mono-recursive">
              Producer Prototype
            </figcaption>
          </div>
        </section>

        {/* Project Overview */}
        <div className="grid md:grid-cols-12 my-12 space-y-12 md:space-y-28">
          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Project Overview</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
            Tuney is a music AI platform that collaborates with producers to curate high-quality data samples, which are then used to train its proprietary LLM. The company’s first product allowed users to generate music entirely from text prompts. While novel, this text-only approach ran into retention challenges: users tended to generate a few songs, listen briefly, and leave. The product wasn’t differentiated enough in the growing AI music market, where many competitors were offering similar one-button generation.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
            To solve this, I led the design of Tuney Producer, a browser-based digital audio workstation (DAW) that embeds AI directly into music-making workflows. Instead of limiting users to text prompts, Producer enables full multitrack editing, contextual AI features inside the timeline, recording capabilities, and the ability to generate or transform entire songs or individual elements. My goal was to reposition Tuney from an AI novelty into a serious creative platform built for musicians, producers, and content creators.
            </p>
          </motion.div>

          <motion.div
            className="col-span-12 flex flex-col justify-center relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg md:rounded-2xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
            <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-64 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
            <div className="z-10 flex flex-col md:flex-row justify-center w-full space-y-12 md:space-y-0 md:space-x-16 p-12 md:p-24">
              <div className="md:w-3/12 flex md:items-center">
                <div className="space-y-2 md:space-y-4">
                  <h3 className="text-xl md:text-2xl font-medium">The Challenge</h3>
                  <p className="max-w-prose lg:leading-normal text-md md:text-lg dark:text-zinc-300">The original Grid experience primarily appealed to a narrow segment of tech-savvy users who were more interested in AI novelty than music creation. These users often experimented briefly before bouncing and rarely converted to paid plans. On the other hand, creators, musicians, producers, and content makers found the tool limiting. It lacked the flexibility and creative control they expected in a true music-making environment.</p>
                </div>
              </div>
              
              <div className="md:w-9/12">
                <motion.figure
                  className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                >
                  <img src={tuneyGridV1} alt="Tuney Grid v1" className="w-full h-auto" />
                </motion.figure>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Understanding the Users</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
              My design process began with a deep dive into user feedback, including Hotjar survey results and community comments. I also monitored Tuney's Discord server and engaged directly with users there. Beyond internal sources, I turned to external communities I'm already active in, such as music production forums and subreddits.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
              I also reached out to several peers in my network who actively write and produce music. These informal interviews helped me understand the broader needs of professional creators and what they expected from a music-making tool.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
              What I discovered was striking. Most of Tuney's existing users weren't musicians. They were curious early adopters of generative AI looking to experiment, often using the platform for background content in vlogs or to compare AI outputs across platforms. Meanwhile, music creators either hadn't discovered Tuney or dismissed it as too limited. There was a clear opportunity to reposition the product and better serve creators who wanted more control and structure in their creative process.
            </p>
          </motion.div>

          {/* User Research Grid */}
          <motion.div
            className="col-span-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="col-span-1 grid md:grid-cols-2 xl:grid-cols-10 gap-4 min-h-0">
              {/* Row 1 on small/medium, spans differently on large */}
              <div className="md:col-span-1 lg:col-span-4 grid gap-4">
                <div className="bg-[#6e4af6] overflow-hidden flex items-center rounded-lg md:rounded-2xl p-6 lg:p-8">
                  <div className="flex flex-col space-y-4">
                    <div className="flex items-center space-x-4">
                      <svg className="w-10 h-10 md:w-12 md:h-12" fill="none" viewBox="0 0 57 57">
                        <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M42.75 49.875a19 19 0 0 0-19-19m0 0a19 19 0 0 0-19 19m19-19c6.558 0 11.875-5.317 11.875-11.875S30.308 7.125 23.75 7.125 11.875 12.442 11.875 19s5.317 11.875 11.875 11.875ZM52.25 47.5c0-8.004-4.75-15.438-9.5-19a11.875 11.875 0 0 0-1.069-19.713" />
                      </svg>
                      <span className="text-3xl md:text-5xl font-bold text-white">134</span>
                    </div>
                    <p className="md:text-lg text-white">Responders</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="relative overflow-hidden flex items-center rounded-lg md:rounded-2xl md:h-full bg-zinc-100 dark:bg-zinc-900 p-6 lg:p-8">
                    <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
                    <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-80 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
                    <div className="flex flex-col space-y-4">
                      <div className="text-3xl md:text-5xl font-bold">29%</div>
                      <p className="md:text-lg">Passive Users</p>
                    </div>
                  </div>
                  <div className="relative overflow-hidden flex items-center rounded-lg md:rounded-2xl md:h-full bg-zinc-100 dark:bg-zinc-900 p-6 lg:p-8">
                    <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
                    <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-80 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
                    <div className="flex flex-col space-y-4">
                      <div className="text-3xl md:text-5xl font-bold">37%</div>
                      <p className="md:text-lg">Detractors</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Donut chart - Row 1 on small/medium */}
              <div className="col-span-1 lg:col-span-2 p-6 lg:p-8 relative overflow-hidden rounded-lg md:rounded-2xl md:h-full min-h-0 bg-zinc-100 dark:bg-zinc-900">
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-80 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
                <div className="flex flex-col justify-center">
                  <div id="donutChart" className="flex flex-col justify-center w-full h-full md:mt-4 lg:mt-8"></div>
                  <div className="flex justify-center gap-4 mt-8">
                    <div className="flex items-center gap-2">
                      <div className="aspect-square w-3 h-3 rounded-full bg-[#3a86ff]"></div>
                      <span className="text-sm">New users</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="aspect-square w-3 h-3 rounded-full bg-[#2ecc71]"></div>
                      <span className="text-sm">Returning users</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Jamie R. persona - Row 2 on small/medium */}
              <div className="col-span-1 lg:col-span-4 pt-6 px-6 lg:pt-8 lg:px-8 relative overflow-hidden rounded-lg md:rounded-2xl md:h-full bg-zinc-100 dark:bg-zinc-900 min-h-0">
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-80 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
                <div className="flex flex-col md:flex-row items-center justify-center gap-8">
                  <figure className="">
                    <img className="w-full h-full max-w-48" src={tuneyUsersPersona} alt="User Persona" />
                  </figure>
                  <div className="flex flex-col justify-center gap-4 p-6 mb-6 bg-zinc-800/10 dark:bg-zinc-800/50 rounded-xl">
                    <div className="space-y-1">
                      <h2 className="font-serif text-2xl">Jamie R.</h2>
                      <p className="text-sm">24 • Gen Z Tech Enthusiast</p>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <h3 className="font-bold">Goals</h3>
                        <ul className="list-disc pl-5 mb-3">
                          <li>Discover and test new AI tools</li>
                          <li>Streamline creative workflow</li>
                          <li>Balance school and side projects</li>
                        </ul>
                      </div>
                      <div>
                        <h3 className="font-bold">Frustrations</h3>
                        <ul className="list-disc pl-5">
                          <li>Clunky user interfaces</li>
                          <li>Lack of integration between tools</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Top survey responses - Row 2 on small/medium */}
              <div className="col-span-1 lg:col-span-4 p-6 lg:p-8 relative overflow-hidden rounded-lg md:rounded-2xl md:h-full bg-[#B61E87] min-h-0">
                <div className="relative flex flex-col text-white h-full">
                  <div className="max-w-prose  lg:leading-normal text-md text-white md:h-full">
                    Top survey responses
                  </div>
                  <div className="relative flex items-center justify-center h-48 md:h-full font-serif lg:!leading-tight text-2xl xl:text-4xl" id="quoteContainer">
                    <div className="quote absolute inset-0 flex items-center justify-center active opacity-100 transition-opacity duration-300">
                      <div>
                        "Better control over song components like intro, verse, chorus, and endings is needed."
                      </div>
                    </div>
                    <div className="quote absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300">
                      <div>
                        "I want to feel like I'm in control of my music."
                      </div>
                    </div>
                    <div className="quote absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300">
                      <div>
                        "I want to be able to use my own samples and loops."
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between items-end w-full md:h-full">
                    <svg className="w-36" fill="none" viewBox="0 0 152 39">
                      <path fill="#fff" d="M39.542 29.572V.038h4.592v11.64c1.444-2.153 3.617-3.225 6.508-3.225 2.467 0 4.375.728 5.721 2.193 1.347 1.455 2.026 3.49 2.026 6.095v12.83h-4.592V17.38c0-3.372-1.503-5.053-4.512-5.053-1.504 0-2.733.452-3.697 1.356-.963.905-1.445 2.183-1.445 3.825v12.063h-4.6ZM80.074 27.025c-2.045 2.035-4.611 3.058-7.698 3.058-3.087 0-5.662-1.023-7.717-3.058-2.055-2.035-3.087-4.63-3.087-7.776s1.032-5.732 3.087-7.757c2.055-2.025 4.63-3.038 7.717-3.038 3.087 0 5.653 1.013 7.698 3.038 2.045 2.025 3.057 4.61 3.057 7.757.01 3.146-1.012 5.731-3.057 7.776ZM68.021 24.43c1.091 1.278 2.546 1.907 4.355 1.907 1.819 0 3.264-.639 4.355-1.907 1.092-1.278 1.633-2.999 1.642-5.181 0-2.153-.55-3.864-1.661-5.142-1.101-1.278-2.556-1.917-4.336-1.907-1.819 0-3.264.63-4.355 1.887-1.091 1.259-1.642 2.98-1.642 5.162.01 2.182.55 3.913 1.642 5.18ZM93.77 30.083c-4.227 0-6.341-2.261-6.341-6.793V12.838h-3.186V8.975h3.313L88.618 2.9h3.441v6.075h8.209v3.864h-8.209v10.323c0 1.897.698 2.85 2.084 2.85 1.308 0 2.478-1.189 3.53-3.568l3.568 1.829c-1.74 3.873-4.237 5.81-7.471 5.81Z" />
                      <path fill="#fff" d="M102.734 39.01c-2.045 0-3.726-.57-5.063-1.701l1.7-3.608c.826.963 1.711 1.445 2.674 1.445 1.279 0 1.918-.826 1.918-2.468V8.966h4.591v23.79c0 2.213-.551 3.805-1.642 4.779-1.082.983-2.477 1.465-4.178 1.474Zm3.529-33.525a2.829 2.829 0 0 1-2.045-.767 2.453 2.453 0 0 1-.609-.894 2.635 2.635 0 0 1-.197-1.062 2.65 2.65 0 0 1 .197-1.072c.137-.344.344-.648.609-.904A3.03 3.03 0 0 1 106.253 0c.747 0 1.475.285 2.035.786.266.256.482.56.63.895.147.344.216.707.206 1.081.01.364-.059.718-.206 1.052-.148.334-.355.63-.62.875-.265.256-.58.462-.934.59a2.877 2.877 0 0 1-1.101.206ZM119.958 30.083c-2.349 0-4.257-.59-5.722-1.76-1.464-1.18-2.192-2.753-2.192-4.739 0-1.808.757-3.352 2.271-4.61 1.514-1.259 3.421-1.888 5.722-1.888 2.349 0 4.335.747 5.958 2.251V16.83c0-1.474-.374-2.615-1.131-3.42-.747-.807-1.819-1.21-3.215-1.21-2.802 0-4.552 1.426-5.23 4.286l-4.208-.894c.571-2.212 1.691-3.952 3.363-5.23 1.671-1.279 3.755-1.908 6.252-1.908 2.723 0 4.866.718 6.439 2.143 1.574 1.436 2.36 3.52 2.36 6.263v12.702h-4.463v-2.596c-1.495 2.084-3.559 3.117-6.204 3.117Zm.855-3.402c2.045 0 3.776-1.022 5.191-3.057v-.64c-1.415-1.7-3.146-2.546-5.191-2.546-1.189 0-2.153.295-2.89.875-.344.256-.629.59-.826.984a2.744 2.744 0 0 0-.285 1.248c-.01.433.079.875.266 1.268.186.393.471.738.816 1.003.727.58 1.7.865 2.919.865ZM135.111 29.572V8.965h4.463v3.57c1.131-2.606 3.088-3.914 5.87-3.914 1.642 0 3.008.541 4.08 1.613 1.081 1.071 1.612 2.516 1.612 4.335a10.046 10.046 0 0 1-.551 3.185l-4.207-.422c.088-.56.147-1.13.167-1.701 0-2.124-.875-3.185-2.635-3.185-1.189 0-2.192.629-2.998 1.887-.807 1.259-1.209 2.92-1.209 4.994v10.244h-4.592ZM10.863 12.121C14.285 10.224 18.974 7.62 18.974.05h-5.673c0 4.237-2.064 5.387-5.19 7.117C4.689 9.064 0 11.67 0 19.24h5.673c0-4.237 2.064-5.387 5.19-7.118ZM20.684 10.381c0 4.237-2.064 5.388-5.19 7.118-3.422 1.897-8.111 4.503-8.111 12.073h5.673c0-4.238 2.064-5.388 5.19-7.118 3.422-1.898 8.111-4.503 8.111-12.073h-5.673Z" />
                    </svg>
                    <div className="relative flex space-x-2">
                      <button className="flex items-center justify-center cursor-pointer w-11 h-11 bg-white/20 hover:bg-white/30 rounded-lg transition duration-150" id="prevBtn">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
                          <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 18-6-6 6-6" />
                        </svg>
                      </button>
                      <button className="flex items-center justify-center cursor-pointer w-11 h-11 bg-white/20 hover:bg-white/30 rounded-lg transition duration-150" id="nextBtn">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
                          <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 18 6-6-6-6" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Survey results - Row 3 on small/medium */}
              <div className="col-span-1 lg:col-span-4 p-6 lg:p-8 relative overflow-hidden rounded-lg md:rounded-2xl md:h-full min-h-0 bg-zinc-100 dark:bg-zinc-900">
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
                <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-80 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
                <div className="space-y-8">
                  <div className="flex space-x-8 items-center justify-between">
                    <div className="flex flex-col space-y-1">
                      <p className=" lg:leading-normal text-md mb-1">Top answer</p>
                      <div className="text-4xl font-bold mb-4">39%</div>
                    </div>
                    <div className="h-fit bg-zinc-200 dark:bg-zinc-800 rounded-lg px-2 py-1 inline-block md:text-lg dark:text-zinc-300">
                      "Generate vocals using a prompt"
                    </div>
                  </div>
                  <div className="space-y-5">
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <div className="space-x-3">
                          <span>Generate vocals using a prompt</span>
                          <span>39%</span>
                        </div>
                        <div className="text-sm text-gray-400 mt-1">72 answers</div>
                      </div>
                      <div className="w-full bg-gray-700 rounded-full h-2.5">
                        <div className="bg-[#645bff] h-2.5 rounded-full" style={{ width: '66%' }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <div className="space-x-3">
                          <span>Upload instrumental for remix</span>
                          <span>19%</span>
                        </div>
                        <div className="text-sm text-gray-400 mt-1">36 answers</div>
                      </div>
                      <div className="w-full bg-gray-700 rounded-full h-2.5">
                        <div className="bg-[#d9415e] h-2.5 rounded-full" style={{ width: '49%' }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <div className="space-x-3">
                          <span>Remove / replace parts of a song</span>
                          <span>17%</span>
                        </div>
                        <div className="text-sm text-gray-400 mt-1">35 answers</div>
                      </div>
                      <div className="w-full bg-gray-700 rounded-full h-2.5">
                        <div className="bg-[#3fb5c3] h-2.5 rounded-full" style={{ width: '47%' }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between text-sm mb-1">
                        <div className="space-x-3">
                          <span>Upload loops/samples to remix</span>
                          <span>13%</span>
                        </div>
                        <div className="text-sm text-gray-400 mt-1">25 answers</div>
                      </div>
                      <div className="w-full bg-gray-700 rounded-full h-2.5">
                        <div className="bg-[#c445c4] h-2.5 rounded-full" style={{ width: '35%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Last box - Row 3 on small/medium */}
              <div className="col-span-1 lg:col-span-2 relative overflow-hidden rounded-lg md:rounded-2xl md:h-full min-h-0 bg-[#7af992]">
                {/* Gradient blur effects */}
                <div className="absolute -right-32 -top-32 w-96 h-80 opacity-50 rotate-45 blur-[300px] bg-gradient-to-r from-[#4ade80] to-[#22c55e]"></div>
                <div className="absolute -left-32 -bottom-32 w-96 h-80 opacity-50 rotate-45 blur-[300px] bg-[#16a34a]"></div>
                
                <div className="relative flex flex-col h-full p-6 lg:p-8">
                  <p className="lg:leading-normal text-md text-zinc-800 mb-1">Weekly engagement</p>
                  
                  <div className="flex items-baseline gap-2 mb-4">
                    <p className="text-4xl font-bold text-zinc-900">-42%</p>
                    <p className="text-xs text-zinc-700">vs last week</p>
                  </div>

                  {/* Line Chart */}
                  <div className="flex-1 flex items-center justify-center mb-4">
                    <svg width="100%" height="140" viewBox="0 0 280 140" className="overflow-visible" preserveAspectRatio="xMidYMid meet">
                      <defs>
                        <linearGradient id="chartGradient" x1="0" x2="0" y1="0" y2="1">
                          <stop offset="0%" stopColor="rgba(22, 163, 74, 0.4)" />
                          <stop offset="100%" stopColor="rgba(22, 163, 74, 0)" />
                        </linearGradient>
                      </defs>
                      
                      {/* Grid lines */}
                      {[0, 1, 2, 3, 4].map((i) => (
                        <line
                          key={i}
                          x1={20}
                          y1={10 + (i * 120) / 4}
                          x2={260}
                          y2={10 + (i * 120) / 4}
                          stroke="rgba(0, 0, 0, 0.1)"
                          strokeWidth="1"
                        />
                      ))}

                      {/* Area under line */}
                      <path 
                        d="M 20 25 L 60 35 L 100 45 L 140 60 L 180 75 L 220 95 L 260 110 L 260 130 L 20 130 Z" 
                        fill="url(#chartGradient)" 
                      />
                      
                      {/* Line */}
                      <path 
                        d="M 20 25 L 60 35 L 100 45 L 140 60 L 180 75 L 220 95 L 260 110" 
                        fill="none" 
                        stroke="#16a34a" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                      />

                      {/* Data points */}
                      {[
                        { x: 20, y: 25 },
                        { x: 60, y: 35 },
                        { x: 100, y: 45 },
                        { x: 140, y: 60 },
                        { x: 180, y: 75 },
                        { x: 220, y: 95 },
                        { x: 260, y: 110 }
                      ].map((point, i) => (
                        <circle 
                          key={i}
                          cx={point.x} 
                          cy={point.y} 
                          r="4" 
                          fill="#16a34a" 
                          stroke="#7af992" 
                          strokeWidth="2.5" 
                        />
                      ))}

                      {/* Day labels */}
                      {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((label, i) => (
                        <text 
                          key={i}
                          x={20 + (i * 40)} 
                          y="138" 
                          textAnchor="middle" 
                          fill="#27272a" 
                          fontSize="11" 
                          fontFamily="Inter, sans-serif"
                        >
                          {label}
                        </text>
                      ))}
                    </svg>
                  </div>

                  {/* Stats */}
                  <div className="flex flex-col gap-2 mt-auto">
                    <div className="flex items-center justify-between">
                      <p className="text-sm text-zinc-700">Lowest day</p>
                      <p className="text-sm font-bold text-zinc-900">Sunday</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <p className="text-sm text-zinc-700">Avg. daily users</p>
                      <p className="text-sm font-bold text-zinc-900">32.4</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <p className="text-sm text-zinc-700">Total sessions</p>
                      <p className="text-sm font-bold text-zinc-900">227</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Key Insights */}
          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Design Objectives</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">To bridge the gap between novelty users and serious creators, I set out to reposition Grid as a true music creation tool. The focus was to build a familiar and flexible DAW-like environment in the browser. This new version would empower users to create and edit audio intuitively, while still offering powerful AI integrations to inspire and assist the process.</p>
          </motion.div>
          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="flex flex-col justify-center relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg md:rounded-2xl p-4 md:p-8">
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-64 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
              <div className="flex items-center space-x-4 md:space-x-6">
                <div className="md:w-12 md:h-12 w-8 h-8 flex items-start md:items-center justify-center">
                  <svg className="w-full h-full" fill="none" viewBox="0 0 48 48">
                    <path stroke="#16C7CB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M44 22.16V24A20 20 0 1 1 32.14 5.72M44 8 24 28.02l-6-6" />
                  </svg>
                </div>
                <div className="space-y-1 w-full">
                  <div className="md:text-lg font-semibold">Professional Tools</div>
                  <p className="dark:text-zinc-400">Provide DAW-level controls with multi-track editing and advanced effects.</p>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg md:rounded-2xl p-4 md:p-8">
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-64 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
              <div className="flex items-center space-x-4 md:space-x-6">
                <div className="md:w-12 md:h-12 w-8 h-8 flex items-start md:items-center justify-center">
                  <svg className="w-full h-full" fill="none" viewBox="0 0 48 48">
                    <path stroke="#16C7CB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M44 22.16V24A20 20 0 1 1 32.14 5.72M44 8 24 28.02l-6-6" />
                  </svg>
                </div>
                <div className="space-y-1 w-full">
                  <div className="md:text-lg font-semibold">Embed AI with the creative flow</div>
                  <p className="dark:text-zinc-400">Add smart features throughout the creative process to enhance productivity.</p>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg md:rounded-2xl p-4 md:p-8">
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -top-80 -left-56 bg-gradient-to-r from-[#7af992] to-[#14351a]"></div>
              <div className="z-0 w-96 h-80 opacity-70 rotate-45 absolute blur-[624px] -bottom-80 -right-64 bg-gradient-to-r from-[#6e4af6] to-[#c63c80]"></div>
              <div className="flex items-center space-x-4 md:space-x-6">
                
                <div className="md:w-12 md:h-12 w-8 h-8 flex items-start md:items-center justify-center">
                  <svg className="w-full h-full" fill="none" viewBox="0 0 48 48">
                  <path stroke="#16C7CB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M44 22.16V24A20 20 0 1 1 32.14 5.72M44 8 24 28.02l-6-6" />
                </svg>
                </div>
                <div className="space-y-1 w-full">
                  <div className="md:text-lg font-semibold">Seamless Integration</div>
                  <p className="dark:text-zinc-400">Connect with existing music production workflows and tools.</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Wireframing Section */}
          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Wireframing to Validate Ideas and Contextual AI Use</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">
              Following the user research phase, I began quickly sketching and building low-fidelity wireframes to validate feature concepts and interaction patterns. My goal was to rapidly test how creators might interact with AI tools inside a traditional DAW-style timeline environment, without overwhelming them or disrupting their creative flow.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">I focused on key scenarios such as:</p>
            <ul className="list-disc pl-5 mb-3 lg:leading-normal text-md md:text-lg dark:text-zinc-400">
              <li>Discover and test new AI tools</li>
              <li>Streamline creative workflow</li>
              <li>Balance school and side projects</li>
            </ul>
          </motion.div>

          {/* Interactive Wireframe Timeline */}
          <motion.div
            className="col-span-12 hidden md:block"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <WireframeTimeline
              tracks={[
                {
                  id: "version-1",
                  name: "Version 1",
                  color: "#10B981",
                  wireframes: [
                    {
                      id: "wf-1",
                      title: "Early sketches 1",
                      timestamp: 0,
                      imageUrl: tuneySketch1,
                      version: "v1.0",
                      track: 0,
                      description: "Initial concept sketches",
                    },
                    {
                      id: "wf-2",
                      title: "Early sketches 2",
                      timestamp: 2.5,
                      imageUrl: tuneySketch2,
                      version: "v1.1",
                      track: 0,
                      description: "Refined initial concepts",
                    },
                  ],
                },
                {
                  id: "version-2",
                  name: "Version 2",
                  color: "#0EA5E9",
                  wireframes: [
                    {
                      id: "wf-3",
                      title: "Lo-fi wireframes 1",
                      timestamp: 4.5,
                      imageUrl: tuneyWireframeLoFi,
                      version: "v2.0",
                      track: 1,
                      description: "Low-fidelity wireframe exploration",
                    },
                  ],
                },
                {
                  id: "version-3",
                  name: "Version 3",
                  color: "#A855F7",
                  wireframes: [
                    {
                      id: "wf-4",
                      title: "Lo-fi wireframes 2",
                      timestamp: 8.5,
                      imageUrl: tuneyWireframe,
                      version: "v3.0",
                      track: 2,
                      description: "Low-fidelity wireframe development",
                    },
                  ],
                },
              ]}
              totalDuration={12}
            />
          </motion.div>

          <motion.figure
            className="col-span-12 md:hidden bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img className="w-full h-auto" src={tuneySketch1} alt="Tuney Quick Start" />
          </motion.figure>

          <motion.figure
            className="col-span-12 md:hidden bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img className="w-full h-auto" src={tuneySketch2} alt="Tuney Quick Start" />
          </motion.figure>

          <motion.figure
            className="col-span-12 md:hidden bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <img className="w-full h-auto" src={tuneyWireframe} alt="Tuney Quick Start" />
          </motion.figure>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">These lo-fi wireframes allowed me to map where and how AI could enhance the experience without becoming intrusive. Rather than treating AI like a separate feature, I embedded its functionality inside context menus, region tools, and track-level controls. This way, AI became part of the user's existing creative behavior, not a separate workflow.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">This phase helped the team prioritize features for the first version of Producer and gave us confidence that AI could be an additive force—supporting creativity rather than abstracting it.
            </p>
          </motion.div>

          <motion.div
            className="col-span-12 grid sm:grid-cols-12 gap-3"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneyQuickStart} alt="Tuney Quick Start" />
              </motion.figure>
            </div>
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneyTimeline} alt="Tuney Timeline" />
              </motion.figure>
            </div>
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneyMyFiles} alt="Tuney My Files" />
              </motion.figure>
            </div>
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneyCoProducerFullScreen} alt="Tuney Co-Producer Full Screen" />
              </motion.figure>
            </div>
          </motion.div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Introducing Producer</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">The reimagined experience began with a redesigned entry point. When users opened Producer, they were greeted by a Quick Start Modal offering multiple ways to begin a new project. They could upload audio from their computer, generate new music from a text or tag prompt, explore Tuney’s curated library of sounds, or connect audio directly from SoundCloud or Dropbox. This created a more accessible and flexible starting point for users with varying skill levels and goals.
            </p>
          </motion.div>

          {/* Interactive Portfolio Section */}
          <div className="col-span-12">
            <PortfolioSection />
          </div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">Once inside the timeline, users interacted with a grid-based interface that mimicked familiar DAW behaviors. Audio regions could be added, looped, dragged, and edited. Users could manipulate individual stems or full tracks, apply changes to entire song sections like verses or choruses, and perform region-level edits. Looping worked like it does in Logic Pro, where dragging the edge of an audio region seamlessly extends playback while replacing overlapping content.</p>
          </motion.div>

          {/* Music Generation Section */}
          <div className="col-span-12">
            <MusicGenerationSection />
          </div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">One of the most powerful enhancements was the integration of AI style transfer and variation tools. These were available at multiple levels, regions, tracks, or markers. A user could, for example, highlight a chorus section and generate new variations based on a prompt like “make this darker and more ambient,” or apply stylistic changes to an entire track using genre or artist-based keywords.</p>
          </motion.div>

          <motion.div
            className="col-span-12 grid sm:grid-cols-12 gap-3"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="sm:col-span-6">
            <motion.video
              className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl bg-black w-full h-full"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              autoPlay
              loop
              muted
              playsInline
              >
              <source src={tuneyAudioRegionStyleTransfer} type="video/mp4" />
              Your browser does not support the video tag.
            </motion.video>
            </div>
            <div className="sm:col-span-6">
            <motion.video
              className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl bg-black w-full h-full"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              autoPlay
              loop
              muted
              playsInline
              >
              <source src={tuneyAudioTrackStyleTransfer} type="video/mp4" />
              Your browser does not support the video tag.
            </motion.video>
            </div>
          </motion.div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">To support this experience further, I introduced an in-app Co-Producer chatbot. It acted as both a musical assistant and an educational guide, capable of performing tasks such as “add a drum loop” or “turn the bass down,” while also answering music theory questions or offering production suggestions. This created a more collaborative dynamic between the user and the AI, especially helpful for newcomers.</p>
          </motion.div>

           <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyCoProducerFullScreenLg} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

           <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">Users could now browse Tuney’s growing sound library more efficiently, selecting from categorized loops, instruments, and stems organized by genre, mood, or artist. For those wanting to bring in their own content, the audio upload flow now supported single file and folder-based stem classification, along with options to remix or replace vocals using AI.
            </p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">Recording was also introduced directly in the browser. The new Record panel allowed users to capture vocals or instruments with visual feedback and adjustable mic settings. They could control volume, mute, input sources, echo cancellation, and even use a metronome. This feature expanded the platform's creative range and supported more traditional workflows.
            </p>
          </motion.div>

          <motion.div
            className="col-span-12 grid sm:grid-cols-12 gap-3"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneySoundLibrary} alt="Tuney Sound Library" />
              </motion.figure>
            </div>
            <div className="sm:col-span-6">
              <motion.figure
                className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <img className="w-full h-auto" src={tuneyRecordAudio} alt="Tuney Record Audio" />
              </motion.figure>
            </div>
          </motion.div>

          <motion.div
            className="col-span-12 lg:col-start-4 lg:col-span-6 space-y-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h2 className="text-xl md:text-2xl font-medium">Outcome</h2>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">Producer successfully repositioned Tuney from an AI novelty platform to a real music creation environment. By introducing familiar workflows and embedding AI in meaningful ways, we created a tool that encouraged users to stay longer, experiment more deeply, and feel in control of their creative output.</p>
            <p className="lg:leading-normal text-md md:text-lg dark:text-zinc-400">Though performance metrics are still being gathered, internal feedback from the team and external reactions from early testers have been very positive. Creators now have a reason to return to Tuney—not just to see what the AI can do, but to collaborate with it.</p>
          </motion.div>

          <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyDesignOne} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

           <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyDesignTwo} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

           <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyDesignThree} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

           <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyDesignFour} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

           <div
             className="col-span-12"
           >
             <motion.figure
               className="bg-zinc-50 dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 overflow-hidden rounded-lg md:rounded-2xl"
               initial={{ opacity: 0 }}
               whileInView={{ opacity: 1 }}
               transition={{ duration: 0.6, ease: "easeOut" }}
               viewport={{ once: true, amount: 0.3 }}
             >
               <img className="w-full h-auto" src={tuneyDesignFive} alt="Tuney Co-Producer Full Screen" />
             </motion.figure>
           </div>

        </div>
      </div>
    </div>
  );
};

export default Tuney;